import { ModelModel } from "./api-models/model";
import { ComponentVariantModel } from "./component-variant";
import { ConfigurationModel } from "./configuration";
import { ManualConfigVariantCreateModel } from "./manual-config-variant-create";
import { ModelSizeModel } from "./model-size";
import { TempleInclinationEnum } from "./variant-temple-inclination";

export class ManualConfigCreateModel {

	public Group?: number | null;
	public Release: Date;
	public ModelId?: number;
	public ModelSizeId?: number;
	public ModelConfigurationId?: number;
	public ManualConfigVariants: Array<ManualConfigVariantCreateModel>;
	public TempleInclination?: TempleInclinationEnum | null;
	public IsPrecious: boolean;
	public ManualConfigCollectionId?: number;
	public ImageUrls?: Array<string> | null;

	public static CreateFromData(group: number | undefined | null,
		releaseDate: Date,
		model: ModelModel | undefined | null,
		configuration: ConfigurationModel | null,
		modelSize: ModelSizeModel | undefined,
		variants: Array<ComponentVariantModel> | undefined,
		templeInclination?: TempleInclinationEnum | null,
		manualConfigCollectionId?: number,
		isPrecious: boolean = false,
		imageUrls: Array<string> | null = null): ManualConfigCreateModel {
		const manualConfigurationVariants: Array<ManualConfigVariantCreateModel> = [];

		variants?.forEach(variant => {
			if (variant.VariantColor) {
				const manualConfigurationVariant = new ManualConfigVariantCreateModel();
				manualConfigurationVariant.ComponentVariantId = variant.Id;
				manualConfigurationVariant.ComponentSizeId = variant.VariantSize?.Id;
				manualConfigurationVariant.ColorId = variant.VariantColor.Color?.Id;
				manualConfigurationVariant.ComponentColorId = variant.VariantColor.Id;
				manualConfigurationVariants.push(manualConfigurationVariant);
			}
		});

		const manualConfiguration = new ManualConfigCreateModel();
		manualConfiguration.ManualConfigVariants = manualConfigurationVariants;
		manualConfiguration.ModelId = model?.Id;
		manualConfiguration.ModelConfigurationId = configuration?.ModelConfigId;
		manualConfiguration.ModelSizeId = modelSize?.Id;
		manualConfiguration.Release = releaseDate;
		manualConfiguration.Group = group;
		manualConfiguration.TempleInclination = templeInclination;
		manualConfiguration.ManualConfigCollectionId = manualConfigCollectionId;
		manualConfiguration.IsPrecious = isPrecious;
		manualConfiguration.ImageUrls = imageUrls;

		return manualConfiguration;
	}

}
